import { render, staticRenderFns } from "./cash-box-info.vue?vue&type=template&id=565d745f&"
import script from "./cash-box-info.vue?vue&type=script&lang=js&"
export * from "./cash-box-info.vue?vue&type=script&lang=js&"
import style0 from "./cash-box-info.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports